<template>
    <div>
        <div v-if="!!settings.data_full_width_responsive">
            <ins 
                :class="settings.class"
                :style="settings.style"
                :data-ad-client="settings.data_ad_client"
                :data-ad-slot="settings.data_ad_slot"
                :data-ad-format="settings.data_ad_format"
                :data-full-width-responsive="settings.data_full_width_responsive">
            </ins>
        </div>
        <div v-else>
            <ins
                :class="settings.class"
                :style="settings.style"
                :data-ad-format="settings.data_ad_format"
                :data-ad-layout-key="settings.data_ad_layout_ke"
                :data-ad-client="settings.data_ad_client"
                :data-ad-slot="settings.data_ad_slot">
            </ins>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'settings'
    ],
    mounted() {
        (adsbygoogle = window.adsbygoogle || []).push({});
    },
}
</script>